import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import PrescriptionDownloadItemContainer from '../../components/PrescriptionDownloadItem/PrescriptionDownloadItemContainer.js';
import { PrescriptionLoader } from '../../components/PrescriptionLoader/PrescriptionLoader.js';
import usePrescriptionDownloads from '../../hooks/use-get-prescription-downloads.js';
import { NoPrescription } from '../../components/NoPrescription/NoPrescription.js';

const PrescriptionDownloadsList = ()=>{
    const { data: prescriptions , loading , error  } = usePrescriptionDownloads();
    const { getLabel , getFormattedLabel  } = useIntl();
    if (loading) {
        return /*#__PURE__*/ React.createElement(PrescriptionLoader, null);
    }
    if (error) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            message: getLabel('common.error.network')
        });
    }
    const hasPrescriptions = prescriptions && prescriptions.length;
    return /*#__PURE__*/ React.createElement("section", {
        className: "prescription-downloads"
    }, !hasPrescriptions && /*#__PURE__*/ React.createElement(NoPrescription, null), hasPrescriptions && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        className: "prescription-downloads__notice"
    }, getFormattedLabel('account.prescription.book-appointment', {
        parseLink: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: "prescription-downloads__list"
    }, prescriptions === null || prescriptions === void 0 ? void 0 : prescriptions.map((prescription)=>/*#__PURE__*/ React.createElement(PrescriptionDownloadItemContainer, {
            key: prescription.id,
            prescription: prescription
        })
    ))));
};
var PrescriptionDownloadsList$1 = PrescriptionDownloadsList;

export { PrescriptionDownloadsList$1 as default };
//# sourceMappingURL=PrescriptionDownloadsList.js.map
